export default class PickStockSaveDetail {
    constructor() {

        this.id = 0;
        this.whJobNumber = '';
        this.consigneeId = 0;
        this.name = '';
        this.addressLine1 = '';
        this.addressLine2 = '';
        this.city = '';
        this.county = '';
        this.postCode = '';
        this.country = '';
        this.contactName = '';
        this.contactTelephone = '';
        this.contactEmail = '';
        this.customerRef = '';
        this.releaseDate = '';
        this.releaseTime = '';
        this.deliveryDate = '';
        this.action = '';
        this.instructions = '';
        this.comment = '';

    }
}